import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Footer for unauthenticated landing pages (HomePage, LoginPage,
// RegisterPage). Today just hosts the Privacy Policy link — Google
// OAuth verification expects it discoverable; users expect it
// findable. Add Terms of Service / Contact when those exist.
export function PublicFooter() {
  const { t } = useTranslation('common');
  return (
    <footer className="mt-8 flex justify-center pb-6 text-sm">
      <Link
        to="/privacy"
        data-testid="footer-privacy-link"
        className="text-muted-foreground underline-offset-2 hover:text-foreground hover:underline"
      >
        {t('footer.privacy_policy')}
      </Link>
    </footer>
  );
}
